import { CanDeactivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const canDeactivateComponentGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return component?.canDeactivate ? component.canDeactivate() : true;
};
